<template>
  <section class="dictionary">
    <div class="row">
      <div class="col">
        <div class="dictionary__head">
          <div class="pt-3 px-2">
            <h1 class="text-center text-white dictionary__title">{{ title }}</h1>
          </div>
          <div class="dictionary__form-search">
            <div class="position-relative d-flex align-items-center mr-3">
              <i class="fa fa-search search-icon"></i>
              <input
                id="search"
                v-model.trim="searchQuery"
                type="text"
                class="form-control"
                aria-describedby="search"
                @keyup.enter="fetchSearch"
              />
            </div>
            <button type="button" class="btn btn-search" @click="fetchSearch">
              {{ $t('dictionary.search') }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="mb-2 mt-3 bg-white dictionary__work-selected">
          <template v-if="wordSelected">
            <WordItem :item="wordSelected" />
          </template>
          <template v-else>
            <h4 class="text-center">{{ $t('dictionary.noWordSelected') }}</h4>
          </template>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <div class="py-4 px-2 my-2 bg-white rounded">
          <h4 class="list-caption my-2">{{ $t('dictionary.list') }} - {{ $t('dictionary.englishResults') }}</h4>
          <!-- <h4 class="float-right"></h4> -->
          <div class="list py-2">
            <ul class="list-group">
              <li
                v-for="(item, key) in words"
                :key="key"
                :class="['list-group-item', { active: active_el === key }]"
                @click="selectWord(item), (active_el = key)"
              >
                <h3 class="list-word">{{ item.word | deleteUnderscore }}</h3>
                <!--<small
                  :class="[
                    'form-text',
                    'mt-0',
                    'word-type',
                    { 'text-muted': active_el != key },
                    { 'text-white': active_el === key },
                  ]"
                >
                  <span>Type:</span>
                  <span
                    :class="['font-italic', { 'text-white': active_el === key }, { 'cod-gray': active_el != key }]"
                    >{{ item.letter | wordType }}</span
                  >
                </small>-->
              </li>
            </ul>
          </div>
          <p v-if="resultsNotFound">{{ $t('dictionary.resultsNotFound') }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import WordItem from './components/WordItem.vue';

export default {
  name: 'Dictionary',
  components: {
    WordItem,
  },
  filters: {
    wordType: function (type) {
      if (type === 'v') {
        return 'Verb';
      }
      if (type === 'n') {
        return 'Noun';
      }
      if (type === 'a' || type === 's') {
        return 'Adjective';
      }
      if (type === 'r') {
        return 'Adverb';
      }
    },
  },
  data() {
    return {
      words: [],
      wordSelected: null,
      searchQuery: '',
      active_el: null,
      resultsNotFound: false,
    };
  },
  computed: {
    title: function () {
      if (
        this.$route.params.grade === 'first-grade' ||
        this.$route.params.grade === 'second-grade' ||
        this.$route.params.grade === 'third-grade' ||
        this.$route.params.grade === 'fourth-grade' ||
        this.$route.params.grade === 'fifth-grade'
      ) {
        return this.$t('dictionary.fullTitle');
      }
      return this.$t('spellingHelperDictionary');
    },
  },
  watch: {
    words: function (list) {
      if (!list.length) return;
      this.active_el = 0;
      this.wordSelected = list[0];
    },
  },
  methods: {
    fetchSearch() {
      const payload = {
        query: this.searchQuery,
      };
      const filtersJSON = JSON.stringify(payload);
      if (!this.searchQuery) return;
      this.active_el = null;
      this.$store.commit('START_PROCESSING');
      this.$httpDictionary
        .get(`synsets?term=search&filters=${filtersJSON}`)
        .then(res => {
          if (!res.data.items.length) {
            this.resultsNotFound = true;
            this.$store.commit('STOP_PROCESSING');
            this.words = [];
            return;
          } else {
            this.resultsNotFound = false;
          }
          this.words = res.data.items;
          this.$store.commit('STOP_PROCESSING');
        })
        .catch(() => {
          this.resultsNotFound = true;
          this.$store.commit('STOP_PROCESSING');
        });
    },
    selectWord(word) {
      this.wordSelected = word;
    },
  },
};
</script>
<style lang="sass" scoped>
.dictionary
  +element('head')
    margin-left: -15px
    margin-right: -15px
    padding: 0 .5em 1em .5em
    background-color: #F8B020
    height: min-content
  +element('title')
    font-size: 25px
  +element('form-search')
    display: flex
    justify-content: center
    .form-control
      border-radius: 1em
      color: #2F9BB5
      padding-left: 2.5em
    .btn-search
      background-color: #0F5F9C
      color: #fff
      border-radius: 1em
    .search-icon
      color: #2F9BB5
      position: absolute
      left: .5em
      font-size: 1.5em
  +element('work-selected')
    border: 2px solid #E4E4E4
    max-width: 900px
    width: 80%
    margin-left: auto
    margin-right: auto
    padding: 1em 2em
    border-radius: 2em

.list,
.list-caption
  max-height: 500px
  max-width: 800px
  width: 80%
  margin-left: auto
  margin-right: auto

.list
  overflow: auto

.list-word
  &:first-letter
    text-transform: uppercase

.list-group-item
  display: flex
  justify-content: space-between
.cod-gray
  color: #1a1a1a
</style>
